import { InputGroup, InputLeftElement, Select, InputRightElement } from '@chakra-ui/react';
import React from 'react';

const ZaraSelect = ({
    children,
    isMobile,
    isSelectFocus,
    setIsSelectFocus,
    setSelectValue,
    selectValue,
    leftIcon,
    groupWidth,
    rightIcon,
    onBlur,
    placeholder,
    ...props
}) => {
    return (
        <InputGroup w={groupWidth}>
            {leftIcon && <InputLeftElement>{leftIcon}</InputLeftElement>}
            <Select
                {...props}
                cursor='pointer'
                fontSize='16px'
                fontWeight='400'
                lineHeight='24px'
                letterSpacing='0em'
                onClick={(e) => (isMobile ? e.stopPropagation() : null)}
                onFocus={() => (isMobile ? (!isSelectFocus ? setIsSelectFocus(true) : null) : null)}
                value={selectValue}
                onBlur={onBlur}
                onMouseDown={() => (!isSelectFocus ? setIsSelectFocus(true) : null)}
                color={isSelectFocus ? 'black' : selectValue ? 'black' : '#718096'}
                placeholder={isSelectFocus ? '' : placeholder}
                onChange={(e) => setSelectValue(e.target.value)}
            >
                <option hidden></option>
                {children}
            </Select>
            {rightIcon && <InputRightElement mr='30px'>{rightIcon}</InputRightElement>}
        </InputGroup>
    );
};

export default ZaraSelect;
